import { useCallback, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { TaskFormData } from '../model/types'
import { buildTaskPdfData } from '../model/taskPdf'
import { downloadTaskPdf } from '../PDF/generateTaskPdf'
import { downloadTaskPdfHtml } from '../PDF/generateTaskPdfHtml'

export function useTaskPdf(getFormData: () => Partial<TaskFormData>, isVmTask: boolean) {
  const translations = useSelector((state: RootState) => state.config.translations)
  const locale = useSelector((state: RootState) => state.general.locale)

  const [isPdfGenerating, setIsPdfGenerating] = useState(false)

  const generatingRef = useRef(false)

  const generatePdf = useCallback(async () => {
    if (generatingRef.current) return
    generatingRef.current = true
    setIsPdfGenerating(true)

    try {
      const pdfData = buildTaskPdfData(getFormData())
      if (isVmTask) {
        const localeTranslations = translations?.[locale] || {}
        await downloadTaskPdfHtml(pdfData, undefined, {
          taskPeriod: localeTranslations['t_start_date'] || 'Task Period',
          deadline: localeTranslations['t_end_date'] || 'Deadline',
          task: localeTranslations['task'] || 'Task',
          category: localeTranslations['category'] || 'Category',
        })
      } else {
        await downloadTaskPdf(pdfData)
      }
    } catch (error) {
      console.error('Failed to generate PDF:', error)
    } finally {
      generatingRef.current = false
      setIsPdfGenerating(false)
    }
  }, [getFormData, isVmTask, translations, locale])

  return { generatePdf, isPdfGenerating }
}
